import { IconButton } from '@chakra-ui/react';
import { Icon, useThState } from '~/ui-components';
import { faSort, faSortUp, faSortDown } from '@fortawesome/pro-duotone-svg-icons';

export type SortByDirections = 'ASC' | 'DESC';

type SortProps = {
   by?: any;
   direction: SortByDirections;
};

type SortColumnButtonProps = {
   name: string;
   sort: SortProps;
   setSort: (value: SortProps) => void;
   opacity?: number;
};

export function SortButton({ name, sort, setSort, opacity }: SortColumnButtonProps) {
   const { isHovered } = useThState();

   let sortIcon = faSort;
   let onClickSort = () => setSort({ by: name, direction: 'DESC' });

   if (sort.by === name && sort.direction === 'DESC') {
      sortIcon = faSortDown;
      onClickSort = () => setSort({ by: name, direction: 'ASC' });
   }

   if (sort.by === name && sort.direction === 'ASC') {
      sortIcon = faSortUp;
      onClickSort = () => setSort({ by: undefined, direction: 'ASC' });
   }

   const getOpacity = () => {
      if (opacity) {
         return opacity;
      }
      return isHovered || sort.by === 'name' ? 1 : 0;
   };

   return (
      <IconButton
         aria-label={'sort'}
         ml={1}
         opacity={getOpacity()}
         size={'sm'}
         icon={<Icon type={sortIcon} />}
         onClick={onClickSort}
         border="none"
         background="none"
         color={sort.by === name ? 'blue.500' : 'blueGray.950'}
      />
   );
}
